import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CardModule } from 'primeng/card';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { TimelineModule } from 'primeng/timeline';
import { ChartModule } from 'primeng/chart';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { StoreModule } from '@ngrx/store';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SharedModule } from '../shared/shared.module';
import { SuperTaskSummaryComponent } from './components/superTask-summary/superTask-summary.component';
// import { PetitionTabComponent } from '../petition-builder/components/petition-tab/petition-tab.component';
import { TaskHeaderComponent } from './components/task-header/task-header.component';
import { TaskSummaryTabComponent } from './components/task-summary-tab/task-summary-tab.component';
import { RfeTabComponent } from './components/rfe-tab/rfe-tab.component';
// import { TaskPageComponent } from '../petition-builder/components/task-page/task-page.component';
import { CreateTaskComponent } from './components/create-task/create-task.component';
import { SuperTaskRoutingModule } from './superTask-routing.module';
import { taskReducer } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { RfeTaskComponent } from './components/create-task/sub-task/rfe/rfe-task.component';
import { PetitionTaskComponent } from './components/create-task/sub-task/petition/petition-task.component';
import { PermTaskComponent } from './components/create-task/sub-task/perm/perm-task.component';
import { I140TaskComponent } from './components/create-task/sub-task/I140/i140-task.component';
import { PetitionTimelineComponent } from '../petition-builder/components/petition-timeline/petition-timeline.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { VisaDesignerModule } from '../visa-designer/visa-designer.module';
import { I130Component } from './components/create-task/sub-task/i130/i130.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { SendNotificationComponent, SendNotificationModule } from 'send-notification';
import { TaskAllocationModule } from '../task-allocation/task-allocation.module';
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { MatTabsModule } from '@angular/material/tabs';
import { DocumentChecklistLibraryModule } from 'document-checklist-library';
import { ExternalLinksModule } from 'external-links';
import { DuplicateDataComponent } from './components/duplicate-data/duplicate-data.component';
import { AutoPopulateComponent } from './components/auto-populate/auto-populate.component';
import { TreeModule } from 'primeng/tree';
// import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { AddInterpreterComponent } from './components/add-interpreter/add-interpreter.component';
import { CreateTaskNewComponent } from './components/create-task-new/create-task-new.component';
import { AddClientCompanyModule } from 'add-client-company';
import { AddPrimaryContactModule } from 'add-primary-contact';
import { AddBeneficiaryOrMemberModule } from 'add-beneficiary-or-member';
import { AddAdditionalDetailsComponent } from './components/task-summary-tab/add-additional-details/add-additional-details.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CreateTaskWithWizardComponent } from './components/create-task-with-wizard/create-task-with-wizard.component';
import { PetitionProcessTypeSelectionComponent } from './petition-process-type-selection/petition-process-type-selection.component';
import { WizardConfirmationDialogComponent } from './components/wizard-confirmation-dialog/wizard-confirmation-dialog.component';
import { TaskDetailsNewComponent } from './components/task-details-new/task-details-new.component';
import { TimelineStepComponent } from './components/timeline-step/timeline-step.component';
import { PetitionStatusComponent } from './components/petition-status/petition-status.component';
import { DocumentChecklistComponent } from './components/document-checklist/document-checklist.component';
import { L1Module } from '../l1-visa/l1.module';


@NgModule({
  declarations: [
    SuperTaskSummaryComponent,
    TaskHeaderComponent,
    CreateTaskComponent,
    TaskSummaryTabComponent,
    TaskDetailsNewComponent,
    PetitionStatusComponent,
    // PetitionTabComponent,
    // TaskPageComponent,
    RfeTabComponent,
    PetitionTimelineComponent,
    RfeTaskComponent,
    PetitionTaskComponent,
    PermTaskComponent,
    I140TaskComponent,
    I130Component,
    DuplicateDataComponent,
    AutoPopulateComponent,
    AddInterpreterComponent,
    CreateTaskNewComponent,
    AddAdditionalDetailsComponent,
    CreateTaskWithWizardComponent,
    PetitionProcessTypeSelectionComponent,
    WizardConfirmationDialogComponent,
    TimelineStepComponent,
    DocumentChecklistComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    L1Module,
    MatIconModule,
    CardModule,
    MatTabsModule,
    InputSwitchModule,
    RadioButtonModule,
    MatSlideToggleModule,
    AccordionModule,
    TabViewModule,
    TimelineModule,
    ChartModule,
    ButtonModule,
    RouterModule,
    FileUploadModule,
    MatFormFieldModule,
    DropdownModule,
    ConfirmDialogModule,
    TableModule,
    DialogModule,
    CalendarModule,
    SuperTaskRoutingModule,
    StoreModule.forFeature('task', taskReducer),
    TooltipModule,
    InputNumberModule,
    CheckboxModule,
    VisaDesignerModule,
    SendNotificationModule,
    DynamicDialogModule,
    TaskAllocationModule,
    MatSelectModule,
    NgbTooltipModule,
    DocumentChecklistLibraryModule,
    ExternalLinksModule,
    TooltipModule,
    TreeModule,
    // TreeSelectModule,
    TreeTableModule,
    DividerModule,
    AutoCompleteModule,
    AddClientCompanyModule,
    AddPrimaryContactModule,
    AddBeneficiaryOrMemberModule,
    MultiSelectModule
  ],
  exports: [
    SuperTaskSummaryComponent,
    TaskHeaderComponent,
    CreateTaskComponent,
    TaskSummaryTabComponent,
    // PetitionTabComponent,
    // TaskPageComponent,
    RfeTabComponent,
    PetitionTimelineComponent,
    RfeTaskComponent,
    PetitionTaskComponent,
    PermTaskComponent,
    I140TaskComponent,
    I130Component,
    DuplicateDataComponent,
    AutoPopulateComponent,
    AddInterpreterComponent,
    CreateTaskNewComponent,
    AddAdditionalDetailsComponent
  ],
  entryComponents: [SendNotificationComponent],
})
export class SuperTaskModule { }